/*
 * @Project_description: 工具
 */
'use strict'
import qs from "qs"
import axios from "axios"
import dayjs from "dayjs"
import lodash from "lodash"
import cookie from 'js-cookie'
import store from '@/store'
import http from './http'
import customHttp from './customHttp'
import tree from 'tree-lodash'
import transform from './transform'
import recorder from './recorder'
import pdf from './pdf'
import EZUIKit from 'ezuikit-js'

cookie.get = function (name) {
    return JSON.parse(window.localStorage.getItem(name))
}

cookie.set = function (name, value, options) {
    window.localStorage.setItem(name, JSON.stringify(value))
}
export default (Vue) => {
    Vue.prototype.$qs = qs
    Vue.prototype.$axios = axios
    Vue.prototype.$dayjs = dayjs
    Vue.prototype.$lodash = lodash
    Vue.prototype.$cookie = cookie
    Vue.prototype.$http = http
    Vue.prototype.$mqtt = window.mqtt
    Vue.prototype.$customHttp = customHttp
    Vue.prototype.$tree = tree
    Vue.prototype.$t = transform
    Vue.prototype.$recorder = recorder
    Vue.prototype.$pdf = pdf
    Vue.prototype.$EZUIKit = EZUIKit
    Window.$qs = qs
    Window.$store = store
    Window.$axios = axios
    Window.$dayjs = dayjs
    Window.$lodash = lodash
    Window.$cookie = cookie
    Window.$http = http
    Window.$tree = tree
    Window.$t = transform
    Window.$recorder = recorder
    Window.$pdf = pdf
}
